import * as echarts from 'echarts/core';

export const HEATMAP_THEME_NAMES = {
  light: 'heatmap-widget-light',
  dark: 'heatmap-widget-dark',
} as const;

export const HEATMAP_THEME_STYLES = {
  light: {
    primary: '#3954D0',
    backgroundColor: '#F7F9FC',
    brightColor: '#1F2C56',
    visualMapLabelColor: 'rgba(6, 21, 43, 0.7)',
    cellBorderColor: 'rgba(215, 223, 238, 0.6)',
    activeBinColor: 'rgba(6, 21, 43, 1)',
  },
  dark: {
    primary: '#7471FF',
    backgroundColor: '#28313f',
    brightColor: '#FFFFFF',
    visualMapLabelColor: 'rgba(255, 255, 255, 0.5)',
    cellBorderColor: 'rgba(7, 7, 19, 0.1)',
    activeBinColor: 'rgba(6, 21, 43, 1)',
  },
} as const;

type HeatmapTheme = Parameters<typeof echarts.registerTheme>[1];

const heatmapThemeConfig: Record<keyof typeof HEATMAP_THEME_NAMES, HeatmapTheme> = {
  light: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    textStyle: {
      color: '#1F2937',
      fontFamily: 'Inter, "Segoe UI", sans-serif',
    },
    categoryAxis: {
      axisLine: {
        lineStyle: { color: 'none' },
      },
      axisLabel: {
        color: 'rgba(6, 21, 43, 0.7)',
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(185, 199, 224, 0.2)', 'rgba(0, 0, 0, 0)'],
        },
      },
      nameTextStyle: {
        color: 'rgba(6, 21, 43, 0.7)',
      },
    },
    visualMap: {
      textStyle: {
        color: 'rgba(6, 21, 43, 0.7)',
      },
    },
    series: {
      itemStyle: {
        borderColor: 'red',
      },
    },
    tooltip: {
      backgroundColor: 'rgba(232, 237, 243, 1)',
      borderColor: 'rgba(183, 196, 222, 1)',
      textStyle: {
        color: 'rgba(6, 21, 43, 1)',
      },
    },
  },
  dark: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    textStyle: {
      color: '#ffffff',
      fontFamily: 'Inter, "Segoe UI", sans-serif',
    },
    categoryAxis: {
      axisLine: {
        lineStyle: { color: 'none' },
      },
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.5)',
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(7, 7, 19, 0.15)', 'rgba(0, 0, 0, 0)'],
        },
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    visualMap: {
      textStyle: {
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    series: {
      itemStyle: {
        borderColor: 'red',
      },
    },
    tooltip: {
      backgroundColor: 'rgba(54, 65, 83, 1)',
      borderColor: 'rgba(229, 229, 255, 0.2)',
      borderRadius: 4,
      textStyle: {
        color: '#ffffff',
      },
    },
  },
};

let themesRegistered = false;

export const registerHeatmapThemes = () => {
  if (themesRegistered) {
    return;
  }
  Object.entries(heatmapThemeConfig).forEach(([mode, theme]) => {
    echarts.registerTheme(HEATMAP_THEME_NAMES[mode as keyof typeof HEATMAP_THEME_NAMES], theme);
  });
  themesRegistered = true;
};

registerHeatmapThemes();
